// src/App.js

import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import { Layout, Modal, Spin } from "antd";

import HeaderBar from "./@shared/HeaderBar";
import Sidebar, { getRouteByCodeKey } from "./@shared/SideBar";
import UserAuth from "./userAuth/UserAuth";
import TestLogin from "./userAuth/TestLogin";
import ExamPage from "./pages/Exam/ExamPage";

import DashboardPage from "./pages/dashboardPage/DashboardPage";
import DispatchCentrePage from "./pages/Dispatch-Centre/dispatchCentrePage/DispatchCentrePage";
import ReportPage from "./pages/ReportPage/ReportPage";
import SummaryPage from "./pages/ReportPage/SummaryPage";
import NotAllowPage from "./pages/NotAllowPage/NotAllowPage";
import ActiveKanban from "./pages/ReportPage/ActiveKanban";

import ViewKanban from "./components/DispatchCentre/ViewKanban";
import ViewGarment from "./components/ManageBin/Garments/ViewGarment";
import AddKanban from "./components/ManageBin/Garments/ManageGarments/AddGarment";
import OverViewGarments from "./components/ManageBin/Garments/ManageGarments/OverViewGarments";
import EditViewGarments from "./components/ManageBin/Garments/ManageGarments/EditGarments/EditViewGarments";

import WashDashboardPage from "./pages/Wash/DashboardPage/WashDashboardPage";
import BinOutwardPage from "./pages/Wash/BinOutwardPage/BinOutwardPage";
import WashReportPage from "./pages/Wash/ReportPage/WashReportPage";
import OutWardConfirm from "./components/Wash/BinOutward/OutWardConfirm";
import BinInwardPage from "./pages/Wash/BinInwardPage/BinInwardPage";
import BinOutwardWashPage from "./pages/Wash/BinOutwardPage/BinOutwardWashPage";
import OutWardWashConfirm from "./components/Wash/BinOutward/OutWardWashConfirm";

import GSMInwardPage from "./pages/GSuperMarketPage/BinInwardPage/GSMInwardPage";
import GSMDashboardPage from "./pages/GSuperMarketPage/DashboardPage/GSMDashboardPage";
import GSM_MasterBinPage from "./pages/GSuperMarketPage/GSM_MasterBinPage/GSM_MasterBinPage";
import GSM_BinStatusPage from "./pages/GSuperMarketPage/GSM_BinStatusPage/GSM_BinStatusPage";
import GSM_OutwardPage from "./pages/GSuperMarketPage/GSM_OutwardPage/GSM_OutwardPage";
import GSM_OutwardConfirm from "./components/GSuperMarket/GSM_Outward/GSM_OutwardConfirm";
import GSM_BinTransitPage from "./pages/GSuperMarketPage/GSM_BinTransitPage/GSM_BinTransitPage";
import GSM_ViewBinTransitPage from "./pages/GSuperMarketPage/GSM_BinTransitPage/GSM_ViewBinTransitPage";
import GSMInwardConfirm from "./components/GSuperMarket/GSMInwatd/GSMInwardConfirm";

import EOLdashboardPage from "./pages/EOLPage/EOL-dashboard/EOLdashboardPage";
import ViewCardDataPage from "./pages/EOLPage/EOL-dashboard/ViewCardDataPage";

import MasterBinPage from "./pages/Dispatch-Centre/DS_MasterBinPage/DS_MasterBinPage";
import BinBlukOutwardPage from "./pages/Dispatch-Centre/BlukOutwardPage/BinBlukOutwardPage";
import BinBulkScan from "./components/DispatchCentre/BlukOutward/Bin/BinBulkScan";
import BinBulkScanPage from "./components/DispatchCentre/BlukOutward/Bin/BinBulkScanPage";
import OutwardPreviewPage from "./pages/Dispatch-Centre/BlukOutwardPage/OutwardPreviewPage";
import OutwaredBinPage from "./pages/ReportPage/Dispatch_Centre/OutwaredBinPage/OutwaredBinPage";

import WASH_MasterBinPage from "./pages/Wash/WASH_MasterBinPage/WASH_MasterBinPage";
import Wash_InwardedBinPage from "./pages/Wash/ReportPage/Wash_InwardedBinPage/Wash_InwardedBinPage";
import WashBinTransitPage from "./pages/Wash/WashBinTransitPage/WashBinTransitPage";
import ViewBinTransitPage from "./pages/Wash/WashBinTransitPage/ViewBinTransitPage";
import Inwardconfirm from "./components/Wash/BinInward/InWardConfirm";
import Wash_BulkInwardPreviewPage from "./pages/Wash/BinInwardPage/Wash_BulkInwardPreviewPage";
import Wash_BulkInwardPage from "./pages/Wash/BinInwardPage/Wash_BulkInwardPage";
import Wash_BulkOutwardPage from "./pages/Wash/BinOutwardPage/Wash_BulkOutwardPage";
import Wash_BulkOutwardPreviewPage from "./pages/Wash/BulkOutwardPage/Wash_BulkOutwardPreviewPage";
import BinBulkScanInward from "./components/Comman/BulkInwardOutward/BinBulkScanInward";
import BinBulkScanOutward from "./components/Comman/BulkInwardOutward/BinBulkScanOutward";

import Gsm_BulkInwardPage from "./pages/GSuperMarketPage/BulkInwardPage/Gsm_BulkInwardPage";
import Gsm_BulkInwardPreviewPage from "./pages/GSuperMarketPage/BulkInwardPage/Gsm_BulkInwardPreviewPage";
import BinBulkScanInwardGsm from "./components/Comman/BulkInwardOutward/BinBulkScanInwardGsm";

import KanbanPlanSheetPage from "./pages/KanbanPlanSheetPage/KanbanPlanSheetPage";
import KanbanCountAccuracyDashbaordPage from "./pages/Kanban-Count-AccuracyPage/Dashboard/KanbanCountAccuracyDashbaordPage";
import KanbanCountAccuracyKanbanScanPage from "./pages/Kanban-Count-AccuracyPage/KanbanScan/KanbanCountAccuracyKanbanScanPage";
import KCA_KanbanScanConfrim from "./components/Kanban-Count-Accuracy/SendToFinishing/KCA_KanbanScanConfrim";
import DailyReportPage from "./pages/Kanban-Count-AccuracyPage/Report/DailyReportPage/DailyReportPage";

import BarcodeReviewPage from "./components/EOL-Checker/EOLC-Review/BarcodReview";
import CapaReportPage from "./components/EOL-Checker/CapaReport/CapaReport";
import Eolc_HourReport from "./pages/EOL-CheckerPage/Eolc_ReportPage/Eolc_HourReport/Eolc_HourReport";

import SupermarketInwardPage from "./pages/SupermarketInwardPage/SupermarketInwardPage";
import SupermarketOutwardPage from "./pages/SupermarketOutwardPage/SupermarketOutwardPage";

import ViewKanbanPage from "./pages/ViewKanbanPage/ViewKanbanPage";
import TimeHistory from "./pages/CriticalOperation/TimeHistory";
import GarmentProductionReport from "./pages/CriticalOperation/GarmentProductionReport";
import HourlyProductionReport from "./pages/CriticalOperation/HourlyProductionReport";
import CriticalMachineDevice from "./pages/CriticalOperation/CriticalMachineDevice";
import CriticalOperationMaster from "./pages/CriticalOperation/CriticalOperationMaster";

import ManageBinDashboard from "./components/ManageBin/Bin/ManageBinDashboard";
import ViewBinData from "./components/Wash/ViewBin/ViewBinData";
import TrackBin from "./pages/TrackBinHistory/TrackBin";
import ViewBinPage from "./pages/Wash/ViewBinPage/ViewBinPage";
import BinMovementTable from "./pages/TrackBinHistory/TrackBinHistory";
import IncentiveLineReport from "./pages/CriticalOperation/IncentiveLineReport";
import ExamTestPage from "./pages/Exam/ExamTestPage";
import ExamResultPage from "./pages/Exam/ExamResultPage";

// Exam Management
import ExamUploadPage from "./pages/Exam/ExamUploadPage";
import ManageExamsPage from "./pages/Exam/ManageExamsPage";
import AssessmentResultsPage from "./pages/Exam/AssessmentResultsPage";
import AssessmentDashboardPage from "./pages/Exam/AssessmentDashboardPage";
import TrainingMaterialPage from "./pages/Exam/TrainingMaterialPage";
import ManageTrainingMaterialPage from "./pages/Exam/ManageTrainingMaterialPage";

import FinishingBacklogReport from "./pages/FinishingBacklogReport";
import CapacityStatusReport from "./pages/CapacityStatusReport";
import CapacityManagement from "./pages/CapacityManagement";
import StyleWiseBacklog from "./pages/StyleWiseBacklog";
import FinishingBacklogAnalytics from "./pages/FinishingBacklogAnalytics";
import MailSettings from "./pages/MailSettings";
const { Content } = Layout;
const { confirm } = Modal;

const FALLBACK_AUTH_ROUTE = "/user-not-allow";

const getFirstAllowedRoute = async (user) => {
  try {
    const deptIds =
      user?.dept_ids ||
      user?.dept ||
      user?.dept_id ||
      user?.department_id;

    if (!deptIds) {
      return FALLBACK_AUTH_ROUTE;
    }

    const formData = new FormData();

    formData.append("dept_id", deptIds);
    formData.append("dept_ids", deptIds);

    const response = await fetch(
      "https://portals.smartekanban.in/index.php/Apiv1/get_navigation_by_dept_ids",
      {
        method: "POST",
        body: formData,
      }
    );

    if (!response.ok) {
      return FALLBACK_AUTH_ROUTE;
    }

    const result = await response.json();

    const menus = Array.isArray(result)
      ? result
      : Array.isArray(result?.data)
      ? result.data
      : [];

    if (!menus.length) {
      return FALLBACK_AUTH_ROUTE;
    }

    // First valid navigation returned by API becomes default page.
    // The URL is resolved from the same menu configuration used by SideBar.
    for (const menu of menus) {
      const route = getRouteByCodeKey(menu.code_key);

      if (route) {
        return route;
      }
    }

    return FALLBACK_AUTH_ROUTE;
  } catch (error) {
    console.error("First allowed route fetch failed:", error);
    return FALLBACK_AUTH_ROUTE;
  }
};

const RootRedirect = ({ isAuthenticated, userdata }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const redirect = async () => {
      if (!isAuthenticated) {
        navigate("/login", { replace: true });
        return;
      }

      if (userdata) {
        const firstRoute = await getFirstAllowedRoute(userdata);
        navigate(firstRoute, { replace: true });
      }
    };

    redirect();
  }, [isAuthenticated, userdata, navigate]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f6f8fb",
      }}
    >
      <Spin size="large" tip="Loading dashboard..." />
    </div>
  );
};

export default function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  const [userdata, setUserdata] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkAuthStatus = () => {
      const logged = localStorage.getItem("isLoggedIn");
      const userData = localStorage.getItem("userData");

      if (logged === "true" && userData) {
        try {
          const parsedData = JSON.parse(userData);
          setUserdata(parsedData?.data || null);
          setIsAuthenticated(true);
        } catch (error) {
          console.error("Error parsing user data:", error);
          localStorage.removeItem("isLoggedIn");
          localStorage.removeItem("userData");
          localStorage.removeItem("unit_code");
          localStorage.removeItem("unit_name");
        }
      }

      setIsLoading(false);
    };

    checkAuthStatus();
  }, []);

  const toggleSidebar = () => setCollapsed((prev) => !prev);

  const handleLogout = () => {
    confirm({
      title: "Confirm Logout",
      content: "Are you sure you want to logout?",
      onOk: () => {
        setIsAuthenticated(false);
        setUserdata(null);

        localStorage.removeItem("isLoggedIn");
        localStorage.removeItem("userData");
        localStorage.removeItem("unit_code");
        localStorage.removeItem("unit_name");

        navigate("/login", { replace: true });
      },
    });
  };

  const handleLoginSuccess = async (data) => {
    const user = data?.data;

    setUserdata(user);
    setIsAuthenticated(true);

    const firstRoute = await getFirstAllowedRoute(user);
    navigate(firstRoute, { replace: true });
  };

  if (isLoading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Spin size="large" tip="Loading..." />
      </div>
    );
  }

  return (
    <Routes>
      <Route
        path="/"
        element={
          <RootRedirect
            isAuthenticated={isAuthenticated}
            userdata={userdata}
          />
        }
      />

      {/* TEST LOGIN */}
      <Route
        path="/test-login"
        element={<TestLogin />}
      />

      {/* EXAM PAGE */}
      <Route
        path="/exam"
        element={<ExamPage />}
      />

      <Route
        path="/exam/test/:examId"
        element={<ExamTestPage />}
      />
      <Route
  path="/training-material"
  element={<TrainingMaterialPage />}
/>


      <Route
        path="/exam/result/:attemptId"
        element={<ExamResultPage />}
      />

      <Route
        path="/login"
        element={
          isAuthenticated ? (
            <Navigate to="/" replace />
          ) : (
            <UserAuth onLoginSuccess={handleLoginSuccess} />
          )
        }
      />

      <Route
        path="/*"
        element={
          !isAuthenticated ? (
            <Navigate to="/login" replace />
          ) : (
            <Layout style={{ minHeight: "100vh", display: "flex" }}>
              <Sidebar
                userData={userdata}
                collapsed={collapsed}
                toggleSidebar={toggleSidebar}
                onLogout={handleLogout}
              />

              <Layout style={{ flex: 1 }}>
                <HeaderBar
                  collapsed={collapsed}
                  toggleSidebar={toggleSidebar}
                  userData={userdata}
                  onLogout={handleLogout}
                />

                <Content
                  style={{
                    margin: "5px 8px",
                    padding: 1,
                    background: "white",
                  }}
                >
                  <Routes location={location}>
                    <Route path="/dashboard" element={<DashboardPage userData={userdata} />} />

                    <Route path="/eol-dashboard" element={<EOLdashboardPage userData={userdata} />} />
                    <Route path="/dashboard/view" element={<ViewCardDataPage userData={userdata} />} />

                    <Route path="/eol-dispatch-kanban" element={<ViewKanban userData={userdata} />} />
                    <Route path="/eol-dispatch-centre" element={<DispatchCentrePage userData={userdata} />} />

                    <Route path="/manage-bin" element={<DashboardPage userData={userdata} />} />
                    <Route path="/view/bin" element={<ViewBinData userData={userdata} />} />
                    <Route path="/manage-bin/view-garment" element={<ViewGarment userData={userdata} />} />
                    <Route path="/manage-bin/add-garment" element={<AddKanban userData={userdata} />} />
                    <Route path="/manage-bin/view/add-garment" element={<OverViewGarments userdata={userdata} />} />
                    <Route path="/manage-bin/edit/garment" element={<EditViewGarments userdata={userdata} />} />

                    <Route path="/report/daily" element={<ReportPage userData={userdata} />} />
                    <Route path="/report/summary" element={<SummaryPage userData={userdata} />} />
                    <Route path="/active/kanban" element={<ActiveKanban userData={userdata} />} />

                    <Route path="/wc-dashboard" element={<WashDashboardPage userdata={userdata} />} />
                    <Route path="/wc-bin-in-transit" element={<WashBinTransitPage userdata={userdata} />} />
                    <Route path="/wc-bin-in-transit/view" element={<ViewBinTransitPage userdata={userdata} />} />

                    <Route path="/wc-bin-inward" element={<BinInwardPage userdata={userdata} />} />
                    <Route path="/wc-bin-inward/confirm" element={<Inwardconfirm userdata={userdata} />} />

                    <Route path="/wc-bin-bulk-inward" element={<Wash_BulkInwardPage userdata={userdata} />} />
                    <Route path="/wc-bin-bulk-inward/scan" element={<BinBulkScanInward userdata={userdata} />} />
                    <Route path="/wc-bin-bulk-inward/preview" element={<Wash_BulkInwardPreviewPage userdata={userdata} />} />

                    <Route path="/wc-bin-outward" element={<BinOutwardWashPage userdata={userdata} />} />
                    <Route path="/wc-bin-outward/confirm" element={<OutWardWashConfirm userdata={userdata} />} />

                    <Route path="/wc-bin-bulk-outward" element={<Wash_BulkOutwardPage userdata={userdata} />} />
                    <Route path="/wc-bin-bulk-outward/scan" element={<BinBulkScanOutward userdata={userdata} />} />
                    <Route path="/wc-bin-bulk-outward/preview" element={<Wash_BulkOutwardPreviewPage userdata={userdata} />} />

                    <Route path="/wc-bin-send-gsm" element={<BinOutwardWashPage userdata={userdata} />} />
                    <Route path="/wc-bin-send-gsm/confirm" element={<OutWardWashConfirm userdata={userdata} />} />

                    <Route path="/wc-bin-master" element={<WASH_MasterBinPage userdata={userdata} />} />
                    <Route path="/wc-bin-status" element={<Wash_InwardedBinPage userdata={userdata} />} />
                    <Route path="/wc-report" element={<WashReportPage userdata={userdata} />} />

                    <Route path="/gsm-dashboard" element={<GSMDashboardPage userdata={userdata} />} />
                    <Route path="/gsm-bin-inward" element={<GSMInwardPage userdata={userdata} />} />
                    <Route path="/gsm-bin-inward/confirm" element={<GSMInwardConfirm userdata={userdata} />} />
                    <Route path="/gsm-bin-view" element={<ViewBinData userdata={userdata} />} />
                    <Route path="/gsm-bin-master" element={<GSM_MasterBinPage userdata={userdata} />} />
                    <Route path="/gsm-bin-status" element={<GSM_BinStatusPage userdata={userdata} />} />
                    <Route path="/gsm-outward" element={<GSM_OutwardPage userdata={userdata} />} />
                    <Route path="/gsm-outward/confirm" element={<GSM_OutwardConfirm userdata={userdata} />} />
                    <Route path="/gsm-in-transit" element={<GSM_BinTransitPage userdata={userdata} />} />
                    <Route path="/gsm-in-transit/view" element={<GSM_ViewBinTransitPage userdata={userdata} />} />
                    <Route path="/gsm-bulk-bin-inward" element={<Gsm_BulkInwardPage userdata={userdata} />} />
                    <Route path="/gsm-bulk-bin-inward/scan" element={<BinBulkScanInwardGsm userdata={userdata} />} />
                    <Route path="/gsm-bulk-bin-inward/preview" element={<Gsm_BulkInwardPreviewPage userdata={userdata} />} />

                    <Route path="/bin-inward/confirm" element={<Inwardconfirm userdata={userdata} />} />
                    <Route path="/outward/bin/confirm" element={<OutWardConfirm userdata={userdata} />} />
                    <Route path="/outward/wc/confirm" element={<OutWardWashConfirm userdata={userdata} />} />

                    <Route path="/dispatch/bulkscan" element={<BinBlukOutwardPage userdata={userdata} />} />
                    <Route path="/dispatch/bulkscan/scan" element={<BinBulkScan userdata={userdata} />} />
                    <Route path="/bulkscan/scan" element={<BinBulkScan userdata={userdata} />} />
                    <Route path="/dispatch/bulkscan/preview" element={<OutwardPreviewPage userdata={userdata} />} />
                    <Route path="/bulkscan/preview" element={<OutwardPreviewPage userdata={userdata} />} />
                    <Route path="/dispatch/bin-master" element={<MasterBinPage userdata={userdata} />} />
                    <Route path="/dispatch/bin/status" element={<OutwaredBinPage userdata={userdata} />} />

                    <Route path="/dc-dashboard" element={<DashboardPage userData={userdata} />} />
                    <Route path="/dc-bulk-bin-outward" element={<BinBlukOutwardPage userdata={userdata} />} />
                    <Route path="/dc-bin-outward" element={<BinOutwardPage userdata={userdata} />} />
                    <Route path="/dc-bulk-bin-outward/scan" element={<BinBulkScanPage userdata={userdata} />} />
                    <Route path="/dc-manage-bin/view-garment" element={<ViewGarment userdata={userdata} />} />

                    <Route path="/kcn-dashboard" element={<KanbanCountAccuracyDashbaordPage userdata={userdata} />} />
                    <Route path="/sent-to-finishing" element={<KanbanCountAccuracyKanbanScanPage userdata={userdata} />} />
                    <Route path="/sent-to-finishing/confirm" element={<KCA_KanbanScanConfrim userdata={userdata} />} />

                    <Route path="/eol-dispatch-dashboard" element={<EOLdashboardPage userData={userdata} />} />
                    <Route path="/eol-dispatch-center" element={<DispatchCentrePage userData={userdata} />} />
                    <Route path="/eol-manage-bin" element={<ManageBinDashboard userData={userdata} />} />
                    <Route path="/eol-manage-bin/view-garment" element={<ViewGarment userData={userdata} />} />

                    <Route path="/eol-dispatch" element={<BarcodeReviewPage />} />
                    <Route path="/eolc/capareport" element={<CapaReportPage />} />
                    <Route path="/report/hour-report" element={<Eolc_HourReport userdata={userdata} />} />

                    <Route path="/kanban-plan-sheet" element={<KanbanPlanSheetPage userdata={userdata} />} />
                    <Route path="/critical-operation/time-operation" element={<TimeHistory userdata={userdata} />} />
                    <Route path="/critical-operation/garment-production" element={<GarmentProductionReport userdata={userdata} />} />
                    <Route path="/critical-operation/hourly-production" element={<HourlyProductionReport userdata={userdata} />} />
                    <Route path="/critical-operation/machine-devices" element={<CriticalMachineDevice userdata={userdata} />} />
                    <Route path="/critical-operation/operation-master" element={<CriticalOperationMaster userdata={userdata} />} />
                    <Route path="/critical-operation/incentive-line-report" element={<IncentiveLineReport />} />

                    <Route path="/supermarket-inward" element={<SupermarketInwardPage userdata={userdata} />} />
                    <Route path="/supermarket-outward" element={<SupermarketOutwardPage userdata={userdata} />} />

                    <Route path="/active-kanban" element={<ActiveKanban />} />
                    <Route path="/track-bin" element={<TrackBin />} />
                    <Route path="/daily-report" element={<DailyReportPage />} />
                    <Route path="/view-bin" element={<ViewBinPage />} />
                    <Route path="/wash/bin-status" element={<Wash_InwardedBinPage />} />
                    <Route path="/bin-status" element={<MasterBinPage />} />
                    <Route path="/dc-bin-report" element={<OutwaredBinPage />} />
                    <Route path="/wc-bin-report" element={<Wash_InwardedBinPage />} />
                    <Route path="/gsm-bin-report" element={<GSM_BinStatusPage />} />
                    <Route path="/bin/movement" element={<BinMovementTable />} />

                    <Route path="/view-kanban/:kanbanNumber" element={<ViewKanbanPage userdata={userdata} />} />

                    {/* ================= EXAM MANAGEMENT ================= */}
                   {/* ================= EXAM MANAGEMENT ================= */}

<Route
  path="/exam-management/dashboard"
  element={<AssessmentDashboardPage userData={userdata} />}
/>

<Route
  path="/exam-management/upload"
  element={<ExamUploadPage userData={userdata} />}
/>

<Route
  path="/training-materials/manage"
  element={
    <ManageTrainingMaterialPage
      userData={userdata}
    />
  }
/>
<Route
  path="/settings/manage-mail"
  element={<MailSettings />}
/>

{/* ================= STYLE-WISE BACKLOG ================= */}
<Route
  path="/style-wise-backlog"
  element={<StyleWiseBacklog userdata={userdata} />}
/>

<Route
  path="/backlog-report"
  element={<FinishingBacklogReport userdata={userdata} />}
/>
<Route
  path="/capacity-status-report"
  element={<CapacityStatusReport userdata={userdata} />}
/>
<Route
  path="/capacity-management"
  element={<CapacityManagement userdata={userdata} />}
/>

<Route
  path="/finishing-backlog-analytics"
  element={<FinishingBacklogAnalytics userdata={userdata} />}
/>
                    <Route
                      path="/exam-management"
                      element={<ManageExamsPage userData={userdata} />}
                    />

                    <Route
                      path="/exam-management/results"
                      element={<AssessmentResultsPage userData={userdata} />}
                    />

                    <Route path="/user-not-allow" element={<NotAllowPage userData={userdata} />} />

                    <Route path="*" element={<Navigate to={FALLBACK_AUTH_ROUTE} replace />} />
                  </Routes>
                </Content>
              </Layout>
            </Layout>
          )
        }
      />
    </Routes>
  );
}
